<template>
  <section class="section">
    <div class="container">
      <h6 class="up-heading">About Us</h6>
      <h2 class="heading-1">Lorem ipsum dolor sit, amet consectetur</h2>
      <p>
        Lorem ipsum dolor sit, amet consectetur adipisicing elit. Aliquid
        possimus vero tempore eius, temporibus id natus similique quam adipisci
        earum esse exercitationem aperiam, tempora delectus accusantium
        praesentium quae doloribus sed!
      </p>
      <p>pralápié</p>
    </div>
  </section>
</template>
